import { Injectable } from '@angular/core';
import { IMultiselectListItem } from 'multi-select-autocomplete-lib';
import { map, Observable, of } from 'rxjs';
import { BullhornEntityFiltersService } from '../bullhorn.entity-filters.service';

@Injectable({ providedIn: 'root' })
export class BullhornPlacementFiltersService extends BullhornEntityFiltersService {
  // These fields are what Bullhorn ATS uses to query placements too.
  static readonly PlacementQueryFields: string = [
    'id',
    'jobOrder(id,title)',
    'candidate(id,firstName,lastName)',
    'employmentType',
    'salary',
    'payRate',
    'clientBillRate',
    'dateBegin',
    'dateEnd',
    'customText1',
    'clientCorporation(id,name)',
  ].join(',');
  static readonly PlacementSearchFields: string[] = [
    'id',
    'jobOrder.id',
    'jobOrder.title',
    'candidate.name',
    'jobOrder.clientCorporation.name',
    'jobOrder.clientContact.name',
  ];

  override entity = 'Placement';
  override entityPath = ['bullhorn', 'Placement'];
  override percentageFields = [
    'taxRate',
    'salesManagerPercentGrossMargin',
    'recruitingManagerPercentGrossMargin',
    'overtimeMarkUpPercentage',
    'markUpPercentage',
    'onboardingPercentComplete',
  ];

  override unsupportedTypes = ['TO_MANY', 'COMPOSITE'];
  override unsupportedDataTypes = ['Timestamp'];
  override relationshipFields = [{ name: 'id', queryFunction: this.queryForPlacements.bind(this) }];

  private queryForPlacements(keyword: string): Observable<IMultiselectListItem[]> {
    if (!keyword || !keyword.trim().length) {
      return of([]);
    }

    keyword = keyword.trim();

    // Build the query
    let query: string;

    // Check if the keyword is a comma-separated list of digits
    if (BullhornEntityFiltersService.COMMA_SEPARATED_DIGITS_REGEX.test(keyword) && keyword.includes(',')) {
      const ids = keyword
        .split(',')
        .map((id) => id.trim())
        .filter((id) => id && BullhornEntityFiltersService.DIGIT_REGEX.test(id)); // Filter out empty and non-numeric values

      if (ids.length > 0) {
        const idQuery = ids.join(' OR ');
        query = `(id: (${idQuery})) AND NOT status:Archive`;
      }
    } else {
      const queryBuild = BullhornPlacementFiltersService.PlacementSearchFields.map((field) => `${field}:${keyword}`).join(' ');
      query = `((${queryBuild})) AND NOT status:Archive`;
    }

    return this.dataSourceApiService
      .query2('Placement', { searchType: 'search', query, fields: BullhornPlacementFiltersService.PlacementQueryFields })
      .pipe(
        map((response) => {
          return response.map((record) => ({
            id: record.id,
            label: `${record.candidate?.firstName || ''} ${record.candidate?.lastName || ''} - ${record.jobOrder?.title || ''}`,
            data: record,
          }));
        })
      );
  }
}
